module.exports = {
  i18n: {
    regions: ["中文", "English"],
    readBtn: "Read More",
    headerTopLeftMenus: [
      {
        name: "About",
        path: "about",
      },
      {
        name: "Job",
        path: "CareerOpportunities",
      },
      {
        name: "download",
        path: "/download",
      },
      {
        name: "Honors",
        path: "/honor",
      },
      {
        name: "contactUs",
        path: "contactUs",
      },
    ],
    developementImg: require('../imgs/developmentHistory_en.png'),
    PRESYSTitle:"PRESYS Valve",
    headerMain: {
      news: "News",
      vacuumValve: "Vacuum valve",
      presys: "presys Valve",
      productService: "Services",
      otherProducts: "Other products",
    },
    headerMainChildren: {
      vacuumValve: "Vacuum valve",
      MGVAGV: "MGV/AGV",
      butterflyValve: "Butterfly valve",
      cornerValve: "Corner Valve",
      highVacuumDirectValve: "High Vacuum Through Valve",
      UHV: "UHV Angle Valve",
      rectangularValve: "Rectangular Valve",
      gate: "gate Valve",
      highVacuumGateValve: "High Vacuum Gate Valve",
      vacuumGateValve: "Vacuum Gate Valve",
      combinedValve: "Combination Valve",
      presys: "presys Valve",
      presysBriefIntroduction: "presys Introduction",
      presysCourse: "presys Course",
      Genius: "Genius Butterfly valve",
      valveRepairDndMaintenance: "Valve repair",
      upgradeDndTransformation: "Upgrades And Renovations",
      serviceCenter: "Service Center",
      throttleValve: "Throttle Valve",
      throttleValveController: "Throttle Valve Controller",
      dualThrottleValve: "Dual Throttle Valve",
      multiPositionController: "Multi Position Controller",
      MNE: "MNE Sealing RingO-RING",
      UNISEMChiller: "UNISEM chiller Temperature control device",
    },
    headerBottomLeftMenus: [
      {
        name: "news",
        path: "/news",
        showDownArrow: false,
      },
      {
        name: "Vacuum Valve",
        path: "",
        showDownArrow: true,
        children: [
          {
            name: "MGV/AGV",
            path: "",
          },
          {
            name: "Butterfly Valve",
            path: "",
          },
          {
            name: "Angle valve",
            path: "",
            children: [
              {
                name: "High Vacuum Gate Valve",
                path: "",
              },
              {
                name: "UHV Angle Valve",
                path: "",
              },
            ],
          },
          {
            name: "Rectangular Valve",
            path: "",
          },
          {
            name: "Gate Valve",
            path: "",
            children: [
              {
                name: "High Vacuum Gate Valve",
                path: "",
              },
              {
                name: "Vacuum Gate Valve",
                path: "",
              },
            ],
          },
          {
            name: "Combination Valve",
            path: "",
          },
        ],
      },
      {
        name: "presys Valve",
        path: "",
        showDownArrow: true,
      },
      {
        name: "Product Services",
        path: "",
        showDownArrow: true,
      },
      {
        name: "Other Products",
        path: "",
        showDownArrow: true,
      },
      {
        name: "查询",
        path: "",
        showSearch: true,
      },
    ],
    homeSwiperList: [
      {
        img: require("../imgs/1-nei-ying.png"),
        imgS: require("../imgs/1-nei-ying.png"),
        imgP: require("../imgs/banner1_en.png"),
        about: "About",
        title: "Company Introduction",
        path: "about",
        content:
          "Jingjiang Jiasheng Vacuum Technology Co., Ltd. was founded in 2018 and is an innovative technology and development of high-performance semiconductor vacuum valves. the first vacuum valve company in South Korea",
      },
      {
        img: require("../imgs/2-nei-ying.png"),
        imgS: require("../imgs/2-nei-ying.png"),
        imgP: require("../imgs/banner2_en.png"),
        about: "Product Services",
        title: "Product Services",
        path: "/valveRepairDndMaintenance",
        content:
          "Strive development rely on integrity to the world. <br>Helping is our unwavering pursuit goal.",
        showStyle: true,
      },
      {
        img: require("../imgs/3-nei-ying.png"),
        imgS: require("../imgs/3-nei-ying.png"),
        imgP: require("../imgs/banner3.png"),
        about: "News",
        title: "Presys. Jiasheng participated in CSEAC2022 Wuxi Exhibition",
        path: "News",
        content:
          "On October 27, 2022, the 10th (CSEAC 2022) China Semiconductor Equipment Annual Conference and Semiconductor",
      },
    ],
    companyIntroduction: "Company Introduction",
    productServices: "Product Services",
    description: "Presys.Jiasheng participated in CSEAC2022 Wuxi Exhibition",
    homeSearchTextOne: "Searching for vacuum valves",
    homeSearchTextTwo: "Thousands of vacuum valve solutions! Find the solution you need!",
    homeSearchTextPlaceholder: "Enter product number or product name",
    search: "FILTER",
    newsVal: "Latest news",
    companyConsultation: "Company Consulting",
    downloadFile: "Download",
    downloadText: "Do you need CAD files, operating instructions, product data sheets, or software updates for valves?",
    downloadTextTwo: "The most frequently visited web pages：",
    downloadCenter: "Download Center",
    vacuumValve: "Vacuum Valve",
    presys: "presys valve",
    genius: "Butterfly Valve",
    otherProducts: "Other Products",
    CoreProducts: "Core Products",
    moreProducts: "More Products",
    proList: [
      {
        img: require("../imgs/proImg1.png"),
        path: "VacuumValve3",
        about: "High vacuum valve",
      },
      {
        img: require("../imgs/proImg2.png"),
        path: "VacuumValve4",
        about: "UHV corner valve",
      },
      {
        img: require("../imgs/proImg3.png"),
        path: "VacuumValve2",
        about: "Butterfly control valve",
      },
      {
        img: require("../imgs/proImg4.png"),
        path: "VacuumValve5",
        about: "Rectangular valve",
      },
      {
        img: require("../imgs/proImg5.png"),
        path: "VacuumValve7",
        about: "Vacuum gate valve",
      },
      {
        img: require("../imgs/proImg6.png"),
        path: "VacuumValve6",
        about: "High vacuum gate valve",
      },
      {
        img: require("../imgs/proImg7.png"),
        path: "VacuumValve8",
        about: "Butterfly valve",
      },
      {
        img: require("../imgs/proImg8.png"),
        path: "VacuumValve1",
        about: "vacuum gate valve",
      },
    ],
    company: "Jiasheng vacuum",
    companyText:
      "Jiasheng Vacuum focuses on the research and development of semiconductor high -performance vacuum valves. In -depth cooperation with South Korea's first vacuum valve company, Presys, and continuously providing products and services to win customers. Excellent innovation and engineering capabilities are the driving force of Jiasheng vacuum providing technical and service solutions. ",
    about: "About",
    aboutText: "recruitment",
    learnMore: "learn more",
    backHome: "Back to top",
    footerList: [
      {
        name: "Product Center",
        path: "",
        children: [
          {
            name: "High vacuum angle valve/direct valve",
            path: "VacuumValve3",
          },
          {
            name: "UHV corner valve",
            path: "VacuumValve4",
          },
          {
            name: "Butterfly control valve",
            path: "VacuumValve2",
          },
          {
            name: "Rectangular valve",
            path: "VacuumValve5",
          },
          {
            name: "Vacuum gate valve",
            path: "VacuumValve7",
          },
          {
            name: "High vacuum gate valve",
            path: "VacuumValve6",
          },
          {
            name: "Butterfly valve and isolation valve",
            path: "VacuumValve8",
          },
          {
            name: "MGV / AGV",
            path: "VacuumValve1",
          },
        ],
        show: false,
      },
      {
        name: "product service",
        show: false,
        children: [
          {
            name: "Valve repair",
            path: "valveRepairDndMaintenance",
          },
          {
            name: "Upgrade and transformation",
            path: "upgradeDndTransformation",
          },
          {
            name: "Service Center",
            path: "serviceCenter",
          },
        ],
      },
      {
        name: "other products",
        show: false,
        children: [
          // {
          //   name: "Throttle Valve",
          //   path: "throttleValve",
          // },
          // {
          //   name: "Throttle Valve Controller",
          //   path: "throttleValveController",
          // },
          // {
          //   name: "Dual Throttle Valve",
          //   path: "dualThrottleValve",
          // },
          // {
          //   name: "Multi Position Controller",
          //   path: "multiPositionController",
          // },
          {
            name: "MNE Sealing ring",
            path: "MNE",
          },
          {
            name: "chiller",
            path: "UNISEMChiller",
          },
        ],
      },
      {
        name: "More information about vacuum valves",
        show: false,
        children: [
          {
            name: "news",
            path: "News",
          },
        ],
      },
      {
        name: "company",
        show: false,
        children: [
          {
            name: "About",
            path: "about",
          },
          {
            name: "Career Opportunities",
            path: "CareerOpportunities",
          },
          {
            name: "Honor",
            path: "honor",
          },
          {
            name: "Contact Us",
            path: "contactUs",
          },
        ],
      },
      {
        name: "customer service",
        show: false,
        children: [
          {
            name: "download",
            path: "download",
          },
        ],
      },
    ],
    companyAbout:
      "2023 靖江佳晟真空技术有限公司 版权所有 苏ICP备2022046328号-1",
    home: "Home Page",
    news: "consultation",
    seeMore: "see more",
    // 佳晟荣誉
    honor: {
      name: "Honor",
      subText: "Unity forge ahead and create glory together",
    },
    // 下载
    downloadPage: {
      name: "download",
      subText: "download",
      brief:
        "You can find the operation description of the product, technical data table or 3D Step file. There must be a product name or product number to determine the file you need to download. The product name or product number can be found directly on the product and delivery documents, or it can be found directly on the products on this website.",
      titleList: [
        {
          index: 1,
          name: "Vacuum valve",
        },
        {
          index: 2,
          name: "presys valve",
        },
        // {
        //   index: 3,
        //   name: "Genius Butterfly valve",
        // },
        {
          index: 4,
          name: "MNE Sealing ring",
        },
        {
          index: 5,
          name: "UNISEM chiller",
        },
      ],
    },
    properties: {
      size: "size:",
      driver: "driver:",
      valveMaterialMaterial: "Valve material:",
      feedingThrough: "Feed:",
      StandardFlanges: "Standard law:",
    },
    MGVAGVpro: {
      title: "Manual/automatic vacuum gate valve",
      homeTitle: "MGV/AGV",
      titleText:
        "For general valves for high vacuum system isolation. It is especially suitable for pump isolation. The cost -effective wave tube seal valve has a long service life.",
      size: 'DN 100-160 mm (4" to 6")',
      driver:
        "Manual: bring a movement hand wheel<br> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Pneumatic: dual action, with position indicator",
      valveMaterialMaterial: "Stainless steel",
      feedingThrough: "Ripple",
      StandardFlanges: "ISO-F，ISO- K",
      downloadTitle: "Butterfly valve and isolation valve",
    },
    butterflyPro: {
      title: "Butterfly control valve",
      homeTitle: "Butterfly valve",
      titleText:
        "The downstream pressure control valve is used for SEMI, FPD, PV, Solar and industrial processes. It is most suitable for fast and high demand craftsmanship, such as CVD. It runs in the dirty process and is reliable to control the performance of excellent pressure. The service port is used to connect the calculator or service box.",
      size: "DN 100-200 (4”-8”)",
      driver: "Integrated pressure controller with step into the motor",
      valveMaterialMaterial: "Aluminum or rust steel",
      feedingThrough: "Rotating feed",
      StandardFlanges: "ISO-F",
      downloadTitle: "Butterfly control valve",
    },
    highVacuumDirectValve: {
      title: "High vacuum direct valve",
      homeTitle: "Corner valve",
      titleText: "Used for gas pumping and exhaust of the atmospheric vacuum system. High pressure difference, long service life.",
      size: "DN16-50 (5/8”-2”)",
      driver:
        "Manual: with movable handwheel<br> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Pneumatic: single acting, with closing spring (N.C.) or opening spring<br> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(N.O.)，Or double acting",
      valveMaterialMaterial: "Aluminum or stainless steel",
      feedingThrough: "corrugated pipe",
      StandardFlanges: "ISO-KF,ISO-K",
      downloadTitle: "High vacuum direct valve",
    },
    UHV: {
      title: "UHV angle valve",
      homeTitle: "angle valve",
      titleText: "Used for suction and exhaust of atmospheric flow vacuum systems. High pressure resistance and long service life.",
      size: "DN 16-63 (5/8”-2",
      driver:
        "Manual: with movable handwheel <br> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Pneumatic: single acting, with closing spring(N.C.)",
      valveMaterialMaterial: "Stainless steel",
      feedingThrough: "corrugated pipe",
      StandardFlanges: "CF-R",
      downloadTitle: "UHV angle valve",
    },
    rectangularValve: {
      title: "Rectangular valve",
      homeTitle: "Rectangular valve",
      titleText:
        "The protected bellows is mechanically locked in the closed position and guided by a fixed L-shaped movement.",
      size: '46×236mm to 50×336mm(1.81"×9.29" to 1.97"×13.23")',
      driver: "Pneumatic: double acting with position indicator",
      valveMaterialMaterial: "aluminium",
      feedingThrough: "corrugated pipe",
      downloadTitle: "Rectangular valve",
    },
    highVacuumGateValve: {
      title: "High vacuum gate valve",
      homeTitle: "Gate valve",
      titleText:
        "Standard valve for vacuum isolation applications in scientific research and industrial fields, with low procurement cost, optional through-hole for direct installation, split design for easy cleaning, and mechanically locked in the closed position.",
      size: 'DN 100-160 mm (4" to 6")',
      driver: "Pneumatic: double acting with position indicator",
      valveMaterialMaterial: "Stainless steel",
      feedingThrough: "Rotating axis feeder",
      StandardFlanges: "ISO-F，cf-f",
      downloadTitle: "High vacuum gate valve",
    },
    vacuumGateValve: {
      title: "Vacuum gate valve",
      homeTitle: "Gate valve",
      titleText:
        "Standard valve for vacuum isolation applications in scientific research and industrial fields, with low procurement cost, optional through-hole for direct installation, split design for easy cleaning, and mechanically locked in the closed position.",
      size: 'DN 80-100 mm (3" to 4")',
      driver: "Pneumatic: double acting with position indicator",
      valveMaterialMaterial: "aluminium",
      feedingThrough: "corrugated pipe",
      StandardFlanges: "ISO-F",
      downloadTitle: "Vacuum gate valve",
    },
    combinedValve: {
      title: "Butterfly valves and isolation valves",
      homeTitle: "Combination valve",
      titleText:
        "The control valve and isolation valve are combined into one, with a compact structure. C1.0 series: B1.0 series butterfly control valve and G1.0 series vacuum gate valve.",
      size: "DN100 (4”)",
      driver: "Integrated pressure controller with stepper motor",
      valveMaterialMaterial: "Stainless steel",
      feedingThrough: "aluminium",
      StandardFlanges: "ISO-F",
      downloadTitle: "Butterfly valves and isolation valves",
    },
    technicalData: "technical data",
    download: "download",
    backVacuum: "Return",
    next: "next page",
    vacuumControlValveQa: "Common Q&A on vacuum valves",
    vacuumControlValveQaList: [
      {
        title: "What is a vacuum valve?",
        text:
          "A vacuum valve is a device installed in the supply or exhaust pipeline of a vacuum system. It is usually used to isolate vacuum areas, such as process rooms, or to control the amount of gas entering and exiting. Vacuum valves can be operated manually, pneumatically, electronically, electrically, or electromagnetic. Vacuum valves are a component of any vacuum system, and vacuum systems are widely used in various industrial production applications.",
      },
      {
        title: "What is a high-performance vacuum valve?",
        text: ["Some vacuum processes have particularly high requirements for the purity, chemical and physical stability of the process environment. For example, this applies to almost all semiconductor production fields, as well as many research facilities that use vacuum systems. In the field of basic research, the ability to handle extreme conditions such as extremely high or low temperatures, strong radiation, and extremely high vacuum (XHV) pressures of up to 10-15 mbar - currently technically feasible and measurable limits - is often added to these requirements.",
          "The vacuum valves in these applications differ from standard vacuum valves in the following aspects:"],
        children: [
          {
            title: "Minimizing particulate emissions",
            text: "The high-performance vacuum valve has been optimized to not release particles through its casing, mechanical devices, or sealing materials, nor through its opening and closing or frictional control of motion. This is achieved through special selection and treatment of the materials used, as well as through certain design details that can minimize or, in some cases, completely eliminate particle release.",
          },
          {
            title: "Minimizing motion pulses",
            text: "Each valve generates motion pulses through its opening and closing motion. In the case of automatic valve actuation, the range of these pulses can range from slight vibrations to audible and perceptible hard impacts. These motion pulses may have a negative impact on sensitive manufacturing processes, for example, by releasing additional particles. In addition to design features, high-performance vacuum valves mainly reduce these pulses by controlling the so-called motion curve. Similar to the operation of passenger elevators, the closing speed will slow down shortly before reaching the closing point to prevent \"impact\". These motion curves can usually be modified, for example, in terms of closing time and closing frequency, they can adapt to the required conditions.",
          },
          {
            title: "Neutral Chemistry and Physical Behavior",
            text: "The vacuum valve always changes the uniformity of the vacuum process chamber, regardless of its form. The occurrence of this situation is partly due to its geometric shape. The narrowing or widening of the flow path can change the flow resistance and velocity, or dead corners, such as the movement space of the valve plate, which can promote the sedimentation process. This also occurs through opening and closing movements, which alter flow behavior and the concentration, distribution, mixing, and temperature of process gases. The high-performance vacuum valve has been optimized to compensate for this impact as much as possible or make it controllable. Therefore, various additional technologies have been incorporated into the design, which far exceed the basic functions of the valve.",
          },
        ]
      },
      {
        title: "What are the types of vacuum valves?",
        text: ["Vacuum valves, like other valves, use some basic mechanical principles such as gate valves, baffle discs, or rotating discs to separate or isolate the vacuum area and control the volumetric flow rate. However, the basic conditions for using these mechanical principles are completely different. For example, high degree of freedom particles, precise control of very small volume flow, sealing, minimal vibration and impact are crucial characteristics. Therefore, these basic mechanical devices are usually designed differently for vacuum valves. For example, the closing mechanism is usually designed to close without friction and cause minimal vibration and impact, if any. In addition, controlling motion can be extremely precise in dosage, with optimized sealing to ensure that no particles are released under ideal conditions, and its static or dynamic characteristics remain stable during long-term use.",
          "The basic types of vacuum valves used are as follows:", "In addition to these basic types, there are also a large number of hybrid variants, some of which combine different valve technologies or provide solutions for certain special requirements.", "Do you want to learn more?", "Please contact us and look forward to communicating with you。"],
        children: [
          {
            title: "<span style='color: #990099'>Vacuum gate valve</span>-Usually an ideal choice for isolation or simpler control applications. The installation depth is very narrow, with the highest conductivity (minimum flow resistance), but the travel space of the gate needs to be limited. These can also take the form of vacuum slit valves, vacuum transfer valves, or vacuum doors, through which products are introduced into the vacuum process chamber.",
          },
          {
            title: "<span style='color: #990099'>Vacuum angle valve</span>-Universal general-purpose vacuum valve. The size is very compact, usually very modular in terms of sealing, actuators, and sensors. The average conductivity is very easy to maintain. Very good, if necessary, with very precise controllability.",
          },
          {
            title: "<span style='color: #990099'>Vacuum butterfly valve</span>-Mainly used for controlling applications. Very narrow installation depth, good conductivity, fast and precise controllability.",
          },
          {
            title: "<span style='color: #990099'>Vacuum swing valve</span>-Very narrow installation depth and compact size, combined with very precise control behavior, excellent insulation ability and very high conductivity.",
          },
          {
            title: "<span style='color: #990099'>Symmetric flow vacuum regulating valve</span>-Special type, optimized for very uniform flow behavior from the first opening to the entire valve opening.",
          },
          {
            title: "<span style='color: #990099'>Gas metering valve or leakage valve</span>-Especially for very precise measurements, such as the measurement of low flow process gases.",
          },
          {
            title: "<span style='color: #990099'>Pressure relief valve or exhaust valve</span>-The safety valve allows the vacuum system to be controlled, usually fully ventilated, and prevents exceeding specified pressure conditions.",
          },
          {
            title: "<span style='color: #990099'>Vacuum check valve</span>-Passive, volume flow and pressure differential operated valves. Usually used to protect vacuum systems from backflow pollution. For example, used between vacuum reflux pumps and vacuum systems.",
          },
          {
            title: "<span style='color: #990099'>Quick closing valve</span>-Active protection valves typically protect large vacuum volumes or chambers from vacuum loss caused by leakage. Main feature: It has a very fast closing response to detected pressure drops. In UHV and XHV applications, it is usually supported by fan-shaped vacuum valves (usually vacuum gate valves) to ensure sealing isolation even at very high pressure differentials.",
          },
          {
            title: "<span style='color: #990099'>Vacuum all metal valve</span>-A set of vacuum valves designed specifically for extreme pressure, temperature, and radiation conditions. Main features: Hard to hard (metal to metal) sealing instead of elastic sealing, as elastic sealing cannot withstand service conditions.",
          },
          {
            title: "<span style='color: #990099'>Vacuum multi valve device</span>-A special type of vacuum valve that combines the functions of several vacuum valves into one unit. Main features: reducing the number of components and fast assembly speed. Usually customized according to customer requirements.",
          },
          {
            title: "<span style='color: #990099'>3 position vacuum valve</span>-A special form of vacuum isolation valve, in which a third valve position can be defined in addition to the closed and open positions. For example, one application is to avoid pressure pulses caused by valve opening too quickly during high pressure differential. In the third position, the contact pressure on the sealing ring slightly decreases in a short period of time, while the valve does not open significantly, making the pressure change more stable.",
          },
        ]
      },


    ],
    backPresys: "Return",
    presysHomeList: [
      {
        path: "presysDetail",
        name: "presysy77",
        img: require("../imgs/presysv77.png"),
        title: "ATM Door <br>TRANSFER DOOR VALVE  SERIES V77 ",
        hidden: false,
        id:9
      },
      {
        path: "presysDetail",
        name: "presysy74",
        img: require("../imgs/presysv74.png"),
        title: "Transfer Valve <br>TRANSFER VALVE L-MO TION, SERIES V74",
        hidden: false,
        id:10
      },
      {
        path: "presysDetail",
        name: "presysy70",
        img: require("../imgs/presysv70.png"),
        title: "Transfer Valve <br>TRANSFER VALVE L-MO TION, SERIES V70 ",
        hidden: false,
        id:11
      },
      {
        path: "presysDetail",
        name: "presysy70Two",
        img: require("../imgs/presysv70Two.png"),
        title: "Transfer Valve <br>NON-STANDARD DOUB LE OPENING L-MOTION,  SERIES V70 ",
        hidden: false,
        id:12
      },
      {
        path: "presysDetail",
        name: "presysy70Three",
        img: require("../imgs/presysv70Three.png"),
        title: "Transfer Valve <br>NON-STANDARD FOUR  OPENING L-MOTION, S ERIES V70 ",
        hidden: false,
        id:13
      },
      {
        path: "presysDetail",
        name: "presysy72",
        img: require("../imgs/presysv72.png"),
        title: "Transfer Valve <br>ALL HEATING TRANSFE R VALVE L-MOTION, SE RIES V72",
        hidden: false,
        id:14
      },
      {
        path: "presysDetail",
        name: "presysy73",
        img: require("../imgs/presysv73.png"),
        title: "Transfer Valve <br>DOUBLE LAYER L-MOTI ON, SERIES V73",
        hidden: true,
        id:15
      },
      {
        path: "presysDetail",
        name: "presysy78",
        img: require("../imgs/presysv78.png"),
        title: "Transfer Valve <br>TRANSFER VALVE I-MOT ION, SERIES V78",
        hidden: true,
        id:16
      },
      {
        path: "presysDetail",
        name: "presysy20",
        img: require("../imgs/presysv20.png"),
        title: "GATE Valve <br>VACUUM GATE VALVE, S ERIES  V20",
        hidden: true,
        id:17
      },
      {
        path: "presysDetail",
        name: "presysy21",
        img: require("../imgs/presysv21.png"),
        title: "GATE Valve <br>HV GATE VALVE, SERIES  V21",
        hidden: true,
        id:18
      },
      {
        path: "presysDetail",
        name: "presysy21Two",
        img: require("../imgs/presysv21Two.png"),
        title: "Uhv Gate Valve <br>UHV GATE VALVE / 3-PO SITION, SERIES V21",
        hidden: true,
        id:19
      },
      {
        path: "presysDetail",
        name: "presysy21Three",
        img: require("../imgs/presysv21Three.png"),
        title: "Uhv Gate Valve <br>WITH HEAT JACKET,SERI ES V21 ",
        hidden: true,
        id:20
      },
      {
        path: "presysDetail",
        name: "presysy60",
        img: require("../imgs/presysv60.png"),
        title: "PTG Valve <br>HV PROTECTION GATE  VALVE, SERIES V60 ",
        hidden: true,
        id:21
      },
      {
        path: "presysDetail",
        name: "presysy41",
        img: require("../imgs/presysv41.png"),
        title: "RPC Angle Valve  <br>REMOTE PLASMA CONT ROL VALVE , SERIES V41 ",
        hidden: true,
        id:22
      },
      {
        path: "presysDetail",
        name: "presysy75",
        img: require("../imgs/presysv75.png"),
        title: "Large Transfer Valve  <br>LARGE TRANSFER VALVE/ DOOR L-MOTION, SERIES  V75 ",
        hidden: true,
        id:23
      },
      {
        path: "presysDetail",
        name: "presysy76",
        img: require("../imgs/presysv76.png"),
        title: "Large Transfer Valve  <br>LARGE TRANSFER VALVE/ INSERT T-MOTION, SERIE S V76",
        hidden: true,
        id:24
      },
    ],
    backTop: "Back Top",
    PresysBriefIntroduction: "PRESYS introduction",
    PresysBriefIntroductionTitle: "PRESYS, a leading global supplier",
    PresysBriefIntroductionText: "An innovative technology enterprise focused on the research and development of high-performance vacuum valves for semiconductors.",
    PresysBriefIntroductionList: [
      {
        title: "Company Name：",
        text: "PRESYS Co.LTD/PRESYS INC",
      },
      {
        title: "CEO：",
        text: "Jun Choen，Seo",
      },
      {
        title: "Date of Incorporation：",
        text: "June 1997",
      },
      {
        title: "capital：",
        text: "1.7 billion Korean won",
      },
      {
        title: "employees：",
        text: "120",
      },
      {
        title: "address：",
        text: "(441-813)1433-64",
      },
      {
        title: "address：",
        text: "(441-813)1433-64，Sewu-ro，Gwonseon-qu，韩国京畿道水原市",
      },
      {
        title: "phone number：",
        text: "+82-31-8003-1133(总部) / +82-31-8003-5100(Direct number)",
      },
      {
        title: "facsimile：",
        text: "+82-31-8003-3399(总部) / +82-31-8003-2849(Direct numbering)",
      },
      {
        title: "other：",
        text: "95 Intellectual Property and Patent Registration and Application",
      },
    ],
    presysProcess: "PRESYS course",
    presysProcessList: [
      {
        year: "2020",
        textList: [
          "Intellectual Property Management Enterprise/Patent Office",
          "China Marketing Start (with Agent)"
        ]
      },
      {
        year: "2018",
        textList: [
          "Selected for the 2017 Global Star Venture Capital Cultivation Project",
          "(Department of Small and Medium Enterprises, Korean Venture Capital Association)"
        ]
      },
      {
        year: "2016",
        textList: [
          "Certified IBK Technology Strong Small Enterprise",
          "Establishment and Operation of Foreign Branches (Silicon Valley, USA)"
        ]
      },
      {
        year: "2015",
        textList: [
          "Foundry Enterprise registration",
          "USA AMAT(Application material)Registered"
        ]
      },
      {
        year: "2014",
        textList: [
          "Certified IBK Technology Strong Enterprise",
          "Samsung Electronics designates a company specialized in training vacuum valves (training component experts)",
          "Obtaining OHSAS 18001 (Safety and Health Systems) certification",
          "New construction and relocation of Shuiyuan Industrial Park (venture capital promotion agency)",
        ]
      },
      {
        year: "2013",
        textList: [
          "Obtained | S0 14001 certification",
        ]
      },
      {
        year: "2011",
        textList: [
          "Fujikin (Japan) - Agent who has signed PRESYS",
        ]
      },
      {
        year: "2009",
        textList: [
          "Awarded in the field of semiconductor equipment new technology innovation for small and medium-sized enterprises in Gyeonggi",
          "Received confirmation letter from INNOBIZ for technological innovation once again"
        ]
      },
      {
        year: "2007",
        textList: [
          "Company change to PRESYS Co., Ltd.",
          "Kurtl.Lesker(USA/Europe) - Agent signed with PRESYS"
        ]
      },
      {
        year: "2006",
        textList: [
          "KOBO A+N Member Selection/Technology Innovation Small and Medium sized Enterprise Certification (INNOBIZ Certification)",
        ]
      },
      {
        year: "2004",
        textList: [
          "Selection of Execution Enterprises for the Development of New Generation Semiconductor Technologies Driven by Growth (Ministry of Industry and Resources)",
          "Selected enterprises for implementing technological innovation (Department of Small and Medium Enterprises)",
        ]
      },
      {
        year: "2003",
        textList: [
          "Obtained 1S0 9001 certification",
        ]
      },
      {
        year: "2002",
        textList: [
          "Commendation/Selection of Excellent Technology Enterprises (Technology Credit Guarantee Fund)",
          "Joining a member company of the Korean Vacuum Society",
        ]
      },
      {
        year: "2001",
        textList: [
          "Research on Developing Ultra Dry Cleaning System/Certified Enterprise Installation",
        ]
      },
      {
        year: "2000",
        textList: [
          "Venture Enterprise Award/Republic of Korea",
          "Joining KSIA, a member company of the Korean Semiconductor Industry Association",
          "Excellent Technology Award (Small and Medium sized Enterprise Department)",
        ]
      },
      {
        year: "1997",
        textList: [
          "Establishment STS CO., Ltd.",
        ]
      },
    ],
    backHomePage: "Back Home",
    APPLICATIONS: "APPLICATIONS",
    MAINFEATURES: "MAIN FEATURES",
    OPTIONS: "OPTIONS",
    presysDetailList: [
      {
        id: 9,
        name: "presysy77",
        bgImg: require("../imgs/ban_bgs.png"),
        bgImgP:  require("../imgs/v77Bg-p.png"),
        img: require("../imgs/v77DetailImg.png"),
        downloadImg: require("../imgs/v77DetailDwonloadImg.png"),
        downloadTitle: "ATM Door",
        downloadText: "TRANSFER DOOR VALVE,  SERIES V77",
        title: "ATM Door",
        titleTwo: "TRANSFER DOOR VALVE,  SERIES V77",
        text: "For load lock and process chamber isolation on the atmosphericside of SEMl production system. Also suitable for PV in-line system.",
        applications: [
          "Semiconductor processing","Plasma Etch, CVD, sputter deposition","Manufacturing of solar panels","LCD / flat panel process","All other cluster and in-line vacuum systems"
        ],
        mainFeatures: [
          "Semi standard application (Semi E21- 94, SemiE24-92, Semi- E21.1-1296) ",
          "Dust seal on the vacuum side of the bonnet flangethat virtually eliminat-es particulate from enteringthe bellows Mechanical lock at the close pos-ition",
          "Particle and vibration free",
          "Realization of exact L-motion",
          "Easy maintenance"
        ],
        options: [
          "Hard anodize","Custom opening size available","Various O-ring (Kalrez® ,Chemraz® etc.)"
        ],
      },
      {
        name: "presysy74",
        bgImg: require("../imgs/v74.png"),
        bgImgP:  require("../imgs/v74Bg-p.png"),
        img: require("../imgs/v74DetailImg.png"),
        downloadImg: require("../imgs/v74DetailDwonloadImg.png"),
        downloadTitle: "Transfer Valve",
        downloadText: "TRANSFER VALVE L-MOTION, SERIES V74",
        title: "Transfer Valve",
        titleTwo: "TRANSFER VALVE L-MOTION, SERIES V74",
        text: "For load lock and process chamber isolation in SEMI production  system. Suitable for corrosive process such as Etch or CVD.",
        applications: [
          "Semiconductor processing",
          "Plasma Etch, CVD, sputter deposition",
          "Manufacturing of solar panels","LCD / flat panel process","All other cluster and in-line vacuum systems"
        ],
        mainFeatures: [
          "Semi standard application (Semi E21- 94, SemiE24-92, Semi- E21.1-1296) ",
          "Patented L-motion link and dual shifts without springs in the actuator enable faster,smoother actuation with siqnificantly reduced vibrationSingl-e pneumatic actuator",
          "Mechanical lock at the close position",
          "Welded bellows actuator seal",
          "Bonnet flange bolts are designed with retainers to eliminate bolts from fa-lling out upon disassembly"
        ],
        options: [
          "Custom opening size available","Stainless steel solution","Various O-ring (Kalrez® ,Chemraz® etc.)"
        ],
      },
      {
        name: "presysy70",
        bgImg: require("../imgs/v70.png"),
        bgImgP:  require("../imgs/v70Bg-p.png"),
        img: require("../imgs/v70DetailImg.png"),
        downloadImg: require("../imgs/v70DetailDownloadImg.png"),
        downloadTitle: "Transfer Valve",
        downloadText: "TRANSFER VALVE L-MOTION, SERIES V70",
        title: "Transfer Valve",
        titleTwo: "TRANSFER VALVE L-MOTION, SERIES V70",
        text: "For load lock and process chamber isolation in SEMI production  system. Suitable for corrosive proc",
        applications: [
          "Semiconductor processing","Plasma Etch, CVD, sputter deposition","Manufacturing of solar panels","LCD / flat panel process","All other cluster vacuum systems"
        ],
        mainFeatures: [
          "Semi standard application (Semi E21- 94, SemiE24-92, Semi- E21.1-1296) ",
          "Low vibration.Patented L-motion link and dual shifts without springs inthe actuator enable faster,smoother actuatione ",
          "Mechanical lock at the close position",
          "Welded bellows actuator seal",
          "Bonnet flange bolts are designed with retainers to eliminate bolts from fa-lling out upon disassembly"
        ],
        options: [
          "Hard anodize","Stainless steel solution", "Custom opening size available", "Various O-ring (Kalrez® ,Chemraz® etc.)"
        ],
      },
      {
        name: "presysy70Two",
        bgImg: require("../imgs/v70-1.png"),
        bgImgP:  require("../imgs/v70TwoBg-p.png"),
        img: require("../imgs/v70TwoDetailImg.png"),
        downloadImg: require("../imgs/v70TwoDetailDwonloadImg.png"),
        downloadTitle: "Transfer Valve",
        downloadText: "NON-STANDARD DOUBLE OPENING L- MOTION, SERIES V70",
        title: "Transfer Valve",
        titleTwo: "NON-STANDARD DOUBLE OPENING L- MOTION, SERIES V70",
        text: "For load lock and process chamber isolation in SEMI production  system. Suitable for corrosive proc",
        applications: [
          "Semiconductor processing","Plasma Etch, CVD, sputter deposition","Manufacturing of solar panels","LCD / flat panel process","All other cluster vacuum systems"
        ],
        mainFeatures: [
          "Semi standard application (Semi E21- 94, SemiE24-92, Semi- E21.1-1296) ",
          "Low vibration.Patented L-motion link and dual shifts without springs inthe actuator enable faster,smoother actuatione ",
          "Mechanical lock at the close position",
          "Welded bellows actuator seal",
          "Bonnet flange bolts are designed with retainers to eliminate bolts from fa-lling out upon disassembly"
        ],
        options: [
          "Hard anodize", "Custom opening size available", "Various O-ring (Kalrez® ,Chemraz® etc.)"
        ],
      },
      {
        name: "presysy70Three",
        bgImg: require("../imgs/v70-2.png"),
        bgImgP:  require("../imgs/v70ThreeBg-p.png"),
        img: require("../imgs/v70ThreeDetailImg.png"),
        downloadImg: require("../imgs/v70ThreeDetailDwonloadImg.png"),
        downloadTitle: "Transfer Valve",
        downloadText: "NON-STANDARD FOUR OPENING L- MOTION, SERIES V70",
        title: "Transfer Valve",
        titleTwo: "NON-STANDARD FOUR OPENING L- MOTION, SERIES V70",
        text: "For load lock and process chamber isolation in SEMI production  system. Suitable for corrosive proc",
        applications: [
          "Semiconductor processing","Plasma Etch, CVD, sputter deposition","Manufacturing of solar panels","LCD / flat panel process","All other cluster vacuum systems"
        ],
        mainFeatures: [
          "Semi standard application (Semi E21- 94, SemiE24-92, Semi- E21.1-1296) ",
          "Low vibration.Patented L-motion link and dual shifts without springs inthe actuator enable faster,smoother actuatione ",
          "Mechanical lock at the close position",
          "Welded bellows actuator seal",
          "Bonnet flange bolts are designed with retainers to eliminate bolts from fa-lling out upon disassembly"
        ],
        options: [
          "Hard anodize", "Custom opening size available", "Various O-ring (Kalrez® ,Chemraz® etc.)"
        ],
      },
      {
        name: "presysy72",
        bgImg: require("../imgs/v72.png"),
        bgImgP:  require("../imgs/v72Bg-p.png"),
        img: require("../imgs/v72DetailImg.png"),
        downloadImg: require("../imgs/v72DetailDwonloadImg.png"),
        downloadTitle: "Transfer Valve",
        downloadText: "ALL HEATING TRANSFER VALVE L- MOTION, SERIES V72",
        title: "Transfer Valve",
        titleTwo: "ALL HEATING TRANSFER VALVE L- MOTION, SERIES V72",
        text: "For load lock and process chamber isolation in SEMI production  system. Suitable for corrosive proc",
        applications: [
          "Semiconductor processing",
          "Plasma Etch, CVD, sputter deposition",
          "Manufacturing of solar panels",
          "LCD / flat panel process",
          "All other cluster vacuum systems"
        ],
        mainFeatures: [
          "Semi standard application (Semi E21- 94, SemiE24-92, Semi- E21.1-1296) ",
          "Low vibration.Patented L-motion link and dual shifts without springs inthe actuator enable faster,smoother actuatione ",
          "Mechanical lock at the close position",
          "Welded bellows actuator seal",
          "Bonnet flange bolts are designed with retainers to eliminate bolts from fa-lling out upon disassembly"
        ],
        options: [
          "Hard anodize", "Custom opening size available", "Various O-ring (Kalrez® ,Chemraz® etc.)"
        ],
      },
      {
        name: "presysy73",
        bgImg: require("../imgs/v73.png"),
        bgImgP:  require("../imgs/v73Bg-p.png"),
        img: require("../imgs/v73DetailImg.png"),
        downloadImg: require("../imgs/v73DetailDwonloadImg.png"),
        downloadTitle: "Transfer Valve",
        downloadText: "DOUBLE LAYER L-MOTION, SERIES V73",
        title: "Transfer Valve",
        titleTwo: "DOUBLE LAYER L-MOTION, SERIES V73",
        text: "For load lock and process chamber isolation in SEMI production  system. Suitable for corrosive process such as Etch or CVD.",
        applications: [
          "Semiconductor processing",
          "Plasma Etch, CVD, sputter deposition",
          "Manufacturing of solar panels",
          "LCD / flat panel process",
          "All other cluster vacuum systems"
        ],
        mainFeatures: [
          "Semi standard application (Semi E21- 94, SemiE24-92, Semi- E21.1-1296) ",
          "Low vibration.Patented L-motion link and dual shifts without springs inthe actuator enable faster,smoother actuatione ",
          "Mechanical lock at the close position",
          "Welded bellows actuator seal",
          "Bonnet flange bolts are designed with retainers to eliminate bolts from fa-lling out upon disassembly"
        ],
        options: [
          "Hard anodize", "Custom opening size available", "Various O-ring (Kalrez® ,Chemraz® etc.)"
        ],
      },
      {
        name: "presysy78",
        bgImg: require("../imgs/v78.png"),
        bgImgP:  require("../imgs/v78Bg-p.png"),
        img: require("../imgs/v78DetailImg.png"),
        downloadImg: require("../imgs/v78DetailDwonloadImg.png"),
        downloadTitle: "Transfer Valve",
        downloadText: "TRANSFER VALVE I-MOTION, SERIES V78 ",
        title: "Transfer Valve",
        titleTwo: "TRANSFER VALVE I-MOTION, SERIES V78 ",
        text: "For load lock and process chamber isolation in SEMI production  system. Suitable for corrosive process such as Etch or CVD.",
        applications: [
          "Semiconductor processing",
          "Pneumatically locked (option)",
          "Plasma Etch, CVD, sputter deposition",
          "Manufacturing of solar panels",
          "LCD / flat panel process"
        ],
        mainFeatures: [
          "Semi standard application (Semi E21- 94, SemiE24-92, Semi- E21.1-1296) ",
          "Low vibration",
          "Long lifetime",
          "Pneumatically locked (option)",
          "Welded bellows actuator seal",
          "Bonnet flange bolts are designed with retainers to eliminate bolts from fa-lling out upon disassembly"
        ],
        options: [
          "Hard anodize", "Stainless steel solution", "Custom opening size available", "Various O-ring (Kalrez® ,Chemraz® etc.)"
        ],
      },
      {
        name: "presysy20",
        bgImg: require("../imgs/v20.png"),
        bgImgP:  require("../imgs/v20Bg-p.png"),
        img: require("../imgs/v20DetailImg.png"),
        downloadImg: require("../imgs/v20DetailDwonloadImg.png"),
        downloadTitle: "GATE Valve",
        downloadText: "VACUUM GATE VALVE, SERIES  V20",
        title: "GATE Valve",
        titleTwo: "VACUUM GATE VALVE, SERIES  V20",
        text: "The standard valve for vacuum isolation application in industry and research.",
        applications: [
          "General vacuum, solar, semiconductor processing",
          "PVD, sputter deposition",
        ],
        mainFeatures: [
          "Low cost of ownership",
          "Good O-ring shaft sealed valve",
          "Shock free with minimum vibration",
          "Aluminum material valve body",
          "Mechanical lock in close position while air failure",
          "DN40-320 with FKM O-ring gate seal",
          "Pneumatic actuators double action",
          "Available in ISO-K, ISO-F metric flange options",
        ],
        options: [
          "Custom specified flange", "Custom opening size available", "Various O-ring (Kalrez® ,Chemraz® etc.) "
        ],
      },
      {
        name: "presysy21",
        bgImg: require("../imgs/v21.png"),
        bgImgP:  require("../imgs/v21Bg-p.png"),
        img: require("../imgs/v21DetailImg.png"),
        downloadImg: require("../imgs/v21DetailDwonloadImg.png"),
        downloadTitle: "GATE Valve",
        downloadText: "HV GATE VALVE, SERIES V21",
        title: "GATE Valve",
        titleTwo: "HV GATE VALVE, SERIES V21",
        text: "General purpose for high vacuum isolation. Especially suit to pump isolation. ",
        applications: [
          "General vacuum, solar, semiconductor processing",
          "PVD, sputter deposition",
        ],
        mainFeatures: [
          "Good bellow sealed valve",
          "Shock free with minimum vibration",
          "Stainless steel material valve body for corrosion resistance",
          "Mechanical lock in close position ",
          "DN63-630 with FKM O-ring gate seal",
          "Pneumatic, manual and 3-Position actuators",
          "Available in ISO-F, CF-F, ASA-LP, JIS flange",
        ],
        options: [
          "Custom specified flange", "Custom opening size available", "Various O-ring (Kalrez® ,Chemraz® etc.) "
        ],
      },
      {
        name: "presysy21Two",
        bgImg: require("../imgs/v21-1.png"),
        bgImgP:  require("../imgs/v21TwoBg-p.png"),
        img: require("../imgs/v21TwoDetailImg.png"),
        downloadImg: require("../imgs/v21TwoDetailDwonloadImg.png"),
        downloadTitle: "GATE Valve",
        downloadText: "UHV GATE VALVE / 3-POSITION, SERIES V21",
        title: "GATE Valve",
        titleTwo: "UHV GATE VALVE / 3-POSITION, SERIES V21",
        text: "General purpose for ultra high vacuum isolation applications in research and industry. Especially suit to pump isolation",
        applications: [
          "Research, semiconductor, solar, general vacuum processing ",
          "PVD, CVD, sputter deposition",
        ],
        mainFeatures: [
          "Good bellow sealed valve",
          "Shock free with minimum vibration",
          "Stainless steel material valve body for corrosion resistance",
          "Mechanical lock in close position ",
          "DN63-320 with FKM O-ring gate seal",
          "Pneumatic, manual and 3-Position actuators",
          "Available in ISO-F, CF-F, ASA-LP, JIS flange",
        ],
        options: [
          "Custom specified flange", "Custom opening size available", "Various O-ring (Kalrez® ,Chemraz® etc.) "
        ],
      },
      {
        name: "presysy21Three",
        bgImg: require("../imgs/v21-2.png"),
        bgImgP:  require("../imgs/v21ThreeBg-p.png"),
        img: require("../imgs/v21ThreeDetailImg.png"),
        downloadImg: require("../imgs/v21ThreeDetailDwonloadImg.png"),
        downloadTitle: "GATE Valve",
        downloadText: "WITH HEAT JACKET,SERIES V21",
        title: "GATE Valve",
        titleTwo: "WITH HEAT JACKET,SERIES V21",
        text: "General purpose for ultra high vacuum isolation applications in research and industry. Especially suit to pump isolation",
        applications: [
          "Research, semiconductor, solar, general vacuum processing ",
          "PVD, CVD, sputter deposition",
        ],
        mainFeatures: [
          "Good bellow sealed valve",
          "Shock free with minimum vibration",
          "Stainless steel material valve body for corrosion resistance",
          "resistance",
          "Mechanical lock in close position ",
          "DN63-320 with FKM O-ring gate seal",
          "Pneumatic, manual and 3-Position actuators",
          "Available in ISO-F, CF-F, ASA-LP, JIS flange",
        ],
        options: [
          "Custom specified flange", "Custom opening size available", "Various O-ring (Kalrez® ,Chemraz® etc.) "
        ],
      },
      {
        name: "presysy60",
        bgImg: require("../imgs/v60.png"),
        bgImgP:  require("../imgs/v60Bg-p.png"),
        img: require("../imgs/v60DetailImg.png"),
        downloadImg: require("../imgs/v60DetailDwonloadImg.png"),
        downloadTitle: "PTG Valve",
        downloadText: "HV PROTECTION GATE VALVE, SERIES V60",
        title: "PTG Valve",
        titleTwo: "HV PROTECTION GATE VALVE, SERIES V60",
        text: "General purpose for high vacuum protection and isolation. Especially  suit to protection and isolation between chamber and pump.",
        applications: [
          "Semiconductor processing",
          "Vacuum pump or chamber isolation in demanding processes",
          "Etch, CVD (MO, PE, HDP, LP) implant, sputter",
          "Nanotechnology process with high particulate levels",
          "Thin film photovoltaic panels",
        ],
        mainFeatures: [
          "Protects process environment from ",
          "down-streaming powder in the event of dry pump ",
          "failure ",
          "Fast pneumatic open & close less than 0.3s",
          "Long cycle life under adverse process conditions",
          "Integrated or independent controller with LCD ",
          "display",
          "Easy routine maintenance ",
        ],
        options: [
          "Independent control of protection ring",
          "1,2,3 or 4 channel control on request",
          "UPS on request",
          "Heat jacket",
        ],
      },
      {
        name: "presysy41",
        bgImg: require("../imgs/v40.png"),
        bgImgP:  require("../imgs/v41Bg-p.png"),
        img: require("../imgs/v41DetailImg.png"),
        downloadImg: require("../imgs/v41DetailDwonloadImg.png"),
        downloadTitle: "RPC Angle Valve",
        downloadText: "REMOTE PLASMA CONTROL VALVE , SERIES V41",
        title: "RPC Angle Valve",
        titleTwo: "REMOTE PLASMA CONTROL VALVE , SERIES V41",
        text: "For upstream cleaning air inflow chamber in SEMI production system. Suitable  for Etch, CVD process.",
        applications: [
          "Semiconductor processing",
          "All CVD process (including MO, PE, HDP, LP and AP)",
          "Manufacturing of solar process",
          "All other cluster and in-line vacuum systems",
        ],
        mainFeatures: [
          "Semi standard application (Semi E21- 94, SemiE24-92, Semi- E21.1-1296) ",
          "Particle free, provide extremely clean updream air inflow chamber",
          "1 million service life cycles",
          "High vacuum angle valve",
          "Pneumatic actuator, double action",
          "Smart and modularization design, easy maintenance",
        ],
        options: [
          "White hard anodized surface treatment ",
          "Custom opening size available",
          "Various O-ring (Kalrez® ,Chemraz® etc.) ",
        ],
      },
      {
        name: "presysy75",
        bgImg: require("../imgs/v75.png"),
        bgImgP:  require("../imgs/v75Bg-p.png"),
        img: require("../imgs/v75DetailImg.png"),
        downloadImg: require("../imgs/v75DetailDwonloadImg.png"),
        downloadTitle: "Large Transfer Valve",
        downloadText: "LARGE TRANSFER VALVE/DOOR L -MOTION, SERIES V75",
        title: "Large Transfer Valve",
        titleTwo: "LARGE TRANSFER VALVE/DOOR L -MOTION, SERIES V75",
        text: "For in-line process chamber isolation in solar, FPD production system.",
        applications: [
          "Solar, FPD processing ",
          "Plasma Etch, CVD, sputter deposition",
          "LCD / flat panel processing",
          "All other application that require pressure controller vacuum systems",
        ],
        mainFeatures: [
          "Reduced vibration significantly by using patented L  -motion link and dual shifts without springs in the actuator enable faster, smoother actuation",
          "Mechanical lock at the close position",
          "Welded bellows actuator seal ",
          "Bonnet flange bolts are designed with retainers to eliminate bolts from falling out upon disassembly",
          "Pneumatic actuator double action",
        ],
        options: [
          "Hard anodize",
          "Stainless steel solution",
          "Various O-ring (Kalrez® ,Chemraz® etc.) ",
        ],
      },
      {
        name: "presysy76",
        bgImg: require("../imgs/v76.png"),
        bgImgP:  require("../imgs/v76Bg-p.png"),
        img: require("../imgs/v76DetailImg.png"),
        downloadImg: require("../imgs/v76DetailDwonloadImg.png"),
        downloadTitle: "Large Transfer Valve",
        downloadText: "LARGE TRANSFER VALVE/INSERT  T-MOTION, SERIES V76",
        title: "Large Transfer Valve",
        titleTwo: "LARGE TRANSFER VALVE/INSERT  T-MOTION, SERIES V76",
        text: "For in-line process chamber isolation in solar, FPD production system.",
        applications: [
          "Solar, FPD processing ",
          "Low shock at high operation speed",
          "position 3 allows to keep one chamber under vacuum while  maintenance work is carried out on the valve",
          "LCD / flat panel processing",
        ],
        mainFeatures: [
          "Reduced vibration significantly by using patented T-motion sealing technology",
          "Mechanical lock function is applied",
          "Welded bellows actuator seal ",
          "Bonnet flange bolts are designed with retainers to eliminate bolts from falling out upon disassembly",
          "Pneumatic actuator double action",
        ],
        options: [
          "Hard anodize",
          "Stainless steel solution",
          "Custom opening size available",
          "Various O-ring (Kalrez® ,Chemraz® etc.) ",
        ],
      },
    ],
    productService: "Product Services",
    valveRepairDndMaintenance: "Valve repair",
    valveRepairDndMaintenanceTitle: "Increased system stability and optimized runtime",
    valveRepairDndMaintenanceText: "We keep your system running.<br>vacuum repair and maintenance services are provided nationwide for you.<br>You need an occasional quick repair.<br>You want to use a service contract to support your production.<br>Please contact us.",
    valveRepairDndMaintenanceMainTitle: "Fast, high-quality, and guaranteed quality",
    valveRepairDndMaintenanceMainText: "Regular maintenance and upkeep are crucial to ensure the normal use of valves. We will provide regular repair and maintenance services for users, including cleaning, maintenance, lubrication, and replacement of parts. We will also provide corresponding emergency repair services for special situations, such as abnormal temperature and pressure, or damage found.<br><br>" +
      "We will have professional technical personnel to troubleshoot the faults encountered by users and provide solutions based on the specific situation of the faults. Select the most suitable solution for user needs to implement according to different situations. Once the fault is resolved, acceptance will be carried out to ensure the safe use of the valve.<br><br>" +
      "With the advancement of technology and the continuous development of the industry, the technical level of valves is also constantly improving. We will provide corresponding upgrade and optimization solutions based on market demand and technological development to improve the performance and service life of valves.",
    contactUs: "contact Us",
    upgradeDndTransformation: "Upgrades and renovations",
    upgradeDndTransformationTitle: "Upgrade and renovation solutions",
    upgradeDndTransformationText: "Stay in sync with innovation and constantly changing production requirements.<br>" +
      "The high-tech manufacturing industry is a cycle of continuous innovation and cost optimization.<br> " +
      "Therefore, production capacity is constantly evolving to meet the latest requirements.",
    upgradeDndTransformationMainTitle: "In order to achieve higher production and higher returns",
    upgradeDndTransformationMainTitleTwo: "Jiasheng Vacuum's vacuum valve upgrade and renovation plan can help achieve increased production, reduced operating costs, faster overall investment returns, and more advantages:",
    upgradeDndTransformationTextList: [
      "Improve (faster and more precise control) valve performance and increase production efficiency",
      "Improving particle performance","Extend normal operating time","Fast and convenient maintenance", "A plug and play solution"
    ],
    serviceCenter: "service center",
    serviceCenterTitle: "Vacuum Service Center",
    serviceCenterText: "If needed, please contact us.",
    serviceCenterMainTitle: "Are you looking for assistance in maintaining the vacuum valve system？ ",
    serviceCenterMainText: "We are continuously expanding our service center network to ensure that our customers receive fast service. In addition to repairing systems and equipment at our service center, our flexible service team also provides on-site services if needed.",
    contactNumber: "phone number：0523-82058068",
    email: "email：jjhr@jiajiaprecise.com",
    address: "address：No. 9 Xinxing Road, Economic and Technological Development Zone, Jingjiang City, Jiangsu Province",
    throttleValveTitle: "Genius butterfly valve",
    throttleValveText: "Main product of our company : Throttle Valve & Controller",
    throttleValveTable: [
      {
        name: "Flapper type",
        text: "Round(Butterfly), Combination,Blade"
      },
      {
        name: "Round type flapper size(lD)",
        text: "25mm~300mm(Non-sealing type) <br> 25mm~160mm (Sealing type) <br> 40mm-100mm(Heating type)"
      },
      {
        name: "Combination type flapper size(ID)",
        text: "100mm~300mm"
      },
      {
        name: "Blade type flapper size(lD)",
        text: "200mm-1000mm"
      },
      {
        name: "Max temperature on Valve body",
        text: "Standard 0℃~100\"C(0ptional:up to 200°C)"
      },
      {
        name: "Max temperature on Valve motor",
        text: "-20℃-50℃"
      },
      {
        name: "From open to close time",
        text: "Less than 1.5sec"
      },
      {
        name: "Resolution/分辨率",
        text: "1/28,800"
      },
      {
        name: "Drive method",
        text: "Direct gear drive"
      },
      {
        name: "External leakage at shaft seal",
        text: "1x10cc/sec,He"
      },
      {
        name: "Material exposed to process",
        text: "AL,SUS.Viton(Standard)"
      },
      {
        name: "Low particle",
        text: "Tefron bushing"
      },
      {
        name: "Compatible pressure controller",
        text: "GT-800.GT-700.MKS 651"
      },
      {
        name: "Flange type/法兰型号",
        text: "NW,ISO,JIS, ANSI(ASA),CF"
      },
    ],
    throttleValveControllerTitle: "Throttle Valve Controller",
    throttleValveControllerText:  [
      "<span style='color: #800080;'>Valve Operated :All Throttle Valves and Others</span>",
      "<span style='color: #800080;'>Pressure Control : Adaptive,PID,Position Set Position</span>",
      "<span style='color:#000;'>Set Position Control (Pressure &Position)</span>"],
    dualThrottleValveText: [
      "<span style='color:#000;'>The first is to</span> <span style='color: #800080;'>control two throttle valves with one controller with Master and Slave mode</span>",
      "<span style='color: #800080;'>Master valve is enabled to position and pressure control, slave valve follows the position value of the that of the master's</span>",
      "<span style='color: #800080;'>The latter is to</span> <span style='color:#000;'>control two step motors with one integral throttle valve</span>",
      "<span style='color: #800080;'>For a combination type and blade type throttle valve controls position from one side and pressure is controlled from the other side.</span>",
    ],
    multiPositionControllerTitle: "Multi Position Controller",
    multiPositionControllerText: [
      "<span style='color: #800080;'>Valve Operated:Position Control</span>",
      "<span style='color: #800080;'>Throttle Valve Control:Max 6 Channel</span>",
      "<span style='color: #000;'>Display Windows : 7-Segment &LED Status & Open, Close, Run</span>",
      "<span style='color: #000;'>Set Point Signal RS-232& RS-485 <br>option :D-NET,Ethernet, EtherCAT</span>",
    ],
    mneHeaderText: "MNE 密封圈O-RING <br>FFKM refers to perfluorinated elastomers, which contain more fluorine than ordinary fluororubber.",
    mneTitle: "MNE O-RING",
    mneText: "FFKM has resistance to high temperatures and various chemical substances, and can withstand for a long time even in the presence of plasma. Especially for specific grades of perfluorinated rubber, it can be continuously used at a maximum of 327 ℃. Based on these characteristics, it has been applied in various industries that require sealing, such as semiconductors and petrochemicals.",
    mneImgTextOne: "FFKM,FKM - Orings",
    mneImgTextTwo: "Bonded Slit Valve",
    mneImgTextThree: "C&C Parts",
    mneDownloadTextOne: "MNE Product - Categorized by Process",
    mneDownloadTextTwo: "MNE Product - Categorized FFKM Physical Properties",
    // mneDownloadTextThree: "MNE Product - Categorized FKM Physical Properties",
    mneDownloadTextThree: "MNE 密封圈O-RING",
    unisemChillerText: "Unisem Chiller Product Line-Up",
    unisemChillerTableOneTh: [
      {
        name: "Class"
      },
      {
        name: "Type"
      },
      {
        name: "Pic"
      },
      {
        name: "Features"
      },
      {
        name: "Temp. Range"
      },
      {
        name: "Cooling Capacity"
      },
      {
        name: "Channels"
      },
      {
        name: "Heater"
      },
      {
        name: "Flowrate"
      },
    ],
    unisemChillerTableOneTr: [
      {
        class: "Refrigerant",
        type: "Refrigerant",
        pic: require('../imgs/unisemChillerTableImg1.png'),
        features: "-. All customized Designed <br>-. Various Cooling capacity<br>-. Compact Design & No leak<br>-. Low power consumption",
        tempRange: "-30°C ~ +60°C",
        coolingCapacity: "3Kw ~ 25Kw @ 0°C",
        channels: "Up to 3",
        heater: "1Kw ~ 8Kw",
        flowrate: "Up to 50LPM",
        classF: true,
      },
      {
        class: "",
        type: "Cryogenic",
        pic: require('../imgs/unisemChillerTableImg2.png'),
        features: "-. BLDC for E-Saving<br>-. Cascade system<br>-. No leakage & Freezing",
        tempRange: "-100°C ~ +50°C",
        coolingCapacity: "2Kw @ -100°C<br>7Kw @ -70°C",
        channels: "Up to 2",
        heater: "1Kw ~ 5Kw",
        flowrate: "Up to 30LPM",
        classF: false,
      },
      {
        class: "Combination",
        type: "Hybrid(Mixing, Switching type)",
        pic: require('../imgs/unisemChillerTableImg3.png'),
        features: "-. Fast temp change under same process<br>-. Use mixing unit for frequent tempt change<br>-. Buffer system for increasing cooling capacity <br> <span style='color: red'>-. Size : 600W x 900D x 1800H(3Ch)</span>",
        tempRange: "-30°C ~ +50°C",
        coolingCapacity: "9w~25Kw @ 0℃ <br>8Kw~12Kw @ 80℃",
        channels: "Up to 3",
        heater: "1Kw ~ 16Kw",
        flowrate: "Up to 30LPM",
        classF: true,
      },
      {
        class: "",
        type: "Combination",
        pic: require('../imgs/unisemChillerTableImg4.png'),
        features: "-. Individual Control by channel<br>-. Diagnosis System.",
        tempRange: "-20°C ~ +90°C",
        coolingCapacity: "2kw~15Kw @ 0℃ <br>8Kw~20Kw @ 80℃",
        channels: "Up to 5",
        heater: "1Kw ~ 10Kw",
        flowrate: "Up to 50LPM",
        classF: false,
      },
    ],
    unisemChillerTableTwoTh: [
      {
        name: "Class"
      },
      {
        name: "Type"
      },
      {
        name: "Pic"
      },
      {
        name: "Features"
      },
      {
        name: "Temp. Range"
      },
      {
        name: "Cooling Capacity"
      },
      {
        name: "Channels"
      },
      {
        name: "Heater"
      },
      {
        name: "Flowrate"
      },
    ],
    unisemChillerTableTwoTr: [
      {
        class: "Heat-exchanger",
        type: "Heat-Exchanger",
        pic: require('../imgs/unisemChillerTableImg5.png'),
        features: "-. Customized Designed<br>-. Various cooling Capacity<br>-. Compact Designed<br>-. Low power consumption",
        tempRange: "-30°C~+160°C",
        coolingCapacity: "2w ~ 30Kw @ 50°C",
        channels: "Up to 5 Or Over",
        heater: "1Kw ~ 20Kw",
        flowrate: "Up to 60LPM",
        classF: true,
      },
      {
        class: "",
        type: "Ultra High Temperature",
        pic: require('../imgs/unisemChillerTableImg6.png'),
        features: "-. Stable operation under high temperature status<br>-. Fume Monitoring System<br>-. No leak with gasket<br>-. Diagnosis System",
        tempRange: "50°C ~ +350°C",
        coolingCapacity: "2Kw~40kw @ 150°C",
        channels: "Up to 2",
        heater: "7Kw ~ 60Kw",
        flowrate: "Up to 60LPM",
        classF: false,
      },
      {
        class: "",
        type: "Built-In",
        pic: require('../imgs/unisemChillerTableImg7.png'),
        features: "-. Compact designed for built in tool<br>-. No leakage issue<br>-. Hardware module swap kit<br> <span style='color: red'>-. Size : 230X x 425D x 645H</span>",
        tempRange: "30°C ~ +90°C",
        coolingCapacity: "8Kw @ 50℃",
        channels: "Up to 2",
        heater: "1Kw ~ 5Kw",
        flowrate: "Up to 30LPM",
        classF: false,
      },
      {
        class: "Electric",
        type: "Electric",
        pic: require('../imgs/unisemChillerTableImg8.png'),
        features: "-. Electric Type<br>-. Low power consumption<br>- BLDC pump for E-saving",
        tempRange: "0°C ~ +70°C",
        coolingCapacity: "5Kw @ 35℃",
        channels: "Up to 2",
        heater: "-",
        flowrate: "Up to 30LPM",
        classF: true,
      },
    ],
    aboutPageTitle: "Relying on precision manufacturing and vacuum perception",
    aboutPageText: "Further pursue cutting-edge technology and provide creative value to the international market. <br>An innovative technology enterprise focused on the research and development of high-performance vacuum valves for semiconductors.",
    aboutList: [
      {
        title: "Jiasheng's core values",
        text: "Putting customers at the center, contributors at the center, adhering to open collaboration, criticism and self-criticism, always acting openly and honestly."
      },
      {
        title: "Jiasheng Mission",
        text: "Propose creative goals, challenge with enthusiasm, focus on the challenges and pressures that customers are concerned about, provide competitive full range of vacuum valve solutions and services, and continuously create maximum value for customers."
      },
      {
        title: "Jiasheng Vision",
        text: "Further pursue cutting-edge technology and become a leader in vacuum valves worldwide"
      },
      {
        name: "Company Introduction",
      },
      {
        name: "contact us",
      },
      {
        name: "Honors",
      },
    ],
    CompanyProfile: "Company Introduction",
    CompanyProfilePageTitle: "Jingjiang Jiasheng Vacuum Technology Co., Ltd. was founded in 2018",
    CompanyProfilePageText: "An innovative technology enterprise focused on the research and development of high-performance vacuum valves for semiconductors.",
    CompanyProfileMainTextOne: "Jingjiang Jiasheng Vacuum Technology Co., Ltd. was founded in 2018 and is an innovative technology enterprise specializing in the research and development of high-performance semiconductor vacuum valves. At the beginning of its establishment, Jiasheng Vacuum collaborated closely with PRESYS, the first vacuum valve company in South Korea, to continuously provide products and services that have won the gratitude of customers. In recent years, PRESYS from South Korea has dispatched the highest technical and high-quality management personnel to China to strengthen close cooperation between the two sides and assist Jiasheng in manufacturing rectangular valves, plug valves, angle valves, RPC valves, butterfly valves, and swing valves in China. Based on excellent innovation and engineering capabilities, Jiasheng Vacuum is the driving force behind providing technology and service solutions.",
    CompanyProfileMainTextTwo: "Our technical team, with a sense of mission of \"Need company\", sets creative goals and challenges with enthusiasm, committed to delving into the core areas of semiconductors and flat panel displays, ultimately achieving breakthroughs and creating new technologies for high vacuum valves and control systems. Based on these technologies, our vacuum valves are fortunate to be able to match the rapidly developing semiconductor industry in China. With so many technological breakthroughs, we have the confidence to become a super first-class Chinese enterprise in high vacuum valves.",
    CompanyProfileMainTextThree: "We focus on vacuum technology innovation as our core competitiveness. From the beginning, we had a thorough understanding of our applications, requirements, and expectations, which is also the cornerstone of our development of new products. ",
    CompanyProfileMainTextFour: "Efficient after-sales service is our commitment, and Jiasheng Vacuum team has been working closely with Chinese customers since 2018.",
    CompanyProfileMainTextFive: "Jiasheng Vacuum's ability to customize products indicates our strong focus on providing customers with solutions: pressure control valves, transfer valves, ATM doors, plug-in valves, swing valves, and angle valve solutions.",
    CompanyProfileMainTextSix: "Our advantages lie in high product reliability, short delivery time, and an experienced technical team.",
    CompanyProfileMainTextSeven: "We provide solutions for all users from Black Vacuum to Extremely High Vacuum.",
    developmentPath: "development history",
    developmentPathPageTitle: "DEVELOPMENT HISTORY",
    developmentPathPageText: "Jingjiang Jiasheng Vacuum Technology Co., Ltd. was founded in 2018 as an innovative technology enterprise focusing on the research and development of high-performance semiconductor vacuum valves.",
    CareerOpportunities: "Job opportunities",
    CareerOpportunitiesText: "Cultivate the life value of employees. Enhance enterprise value and lead the vacuum industry.",
    CareerOpportunitiesPageTitle: "Why add Jiasheng Vacuum？",
    CareerOpportunitiesPageList: [
      {
        title: "Talent development",
        text: "Talent development is one of our key strategic priorities, reflecting our commitment to our employees. We deeply understand that investing in employees is the key to our long-term success. We will tailor action plans for employees based on talent management and succession planning, in order to promote talent development and growth. We strongly support the cultivation of employee leadership and the development of technology, encouraging employees to explore our business more deeply and extensively."
      },
      {
        title: "Growth is the key to creating opportunities",
        text: "Working for a successful and constantly growing company like Jiasheng Vacuum means you will have many opportunities to encounter challenging tasks and transformative projects. Without talent, we cannot expand into new product lines, businesses, fields, or markets. The first place we look for talent is our own team. You will find many growth opportunities in our company."
      },
      {
        title: "Personal career development",
        text: "Working for Jiasheng vacuum means working for a fast-paced, exciting, and collaborative company. You will have the opportunity to participate in building products, companies, and your own career. There is no rigid pre-defined career path here. With our support, you will have the opportunity to use your own way to gain experience in adding streams or expanding the space, and continue to move forward on your career path. If you want to make a difference in your next job, Jiajiayuan and Zili Yangban are definitely the right choices."
      },
    ],
    recruitment: "Recruitment positions",
    seeMoreRecruitment: "View more recruitment positions",
    recruitmentText: "Cultivate the life value of employees. Enhance enterprise value and lead the vacuum industry.",
    recruitmentList: [
      {
        name: "Department: High Vacuum Business Unit",
        isShow: true,
        list: [
          {
            type: "Recruitment position:",
            typeText: "assemble",
            planPeople: "Planning personnel:",
            planPeopleText: "5 person",
            job: "duty:",
            jobText: "Assembly of high vacuum valves in the semiconductor, panel display, and photovoltaic industries; <br>" +
              "Able to understand mechanical assembly drawings, familiar with assembly and fitter processes, and perform production assistance work according to production plans;<br>" +
              "Strictly follow the process requirements for photo inspection, cleaning, and ingredient preparation during assembly, ensuring the quality of door assembly, using tools reasonably, achieving safety improvement, civilized production, maintaining cleanliness in the work area, returning equipment and tools, and completing other related work.",
            salary: "Salary Information:",
            salaryText: "<span style='color: #6C2188'>5000-7000</span>",
          },
          {
            type: "Recruitment position:",
            typeText: "charge",
            planPeople: "Planning personnel:",
            planPeopleText: "1 person",
            job: "duty:",
            jobText: "Responsible for formulating and implementing production plans, and supervising the implementation of production plans to ensure production progress and product quality; <br>" +
              "Responsible for production site management and production quality control, ensuring that the production site meets company requirements and the production process meets standards;<br>" +
              "Responsible for the daily management and training of production personnel, improving employee skills and production efficiency;<br>" +
              "Responsible for the maintenance and management of production equipment, ensuring the normal operation of production equipment;<br>" +
              "Assist other departments in completing related tasks, such as collaborating with other departments to complete procurement, logistics, quality inspection, etc., consciously abide by the company's various rules and regulations, and obey other related work arranged by leaders.",
            salary: "Salary Information:",
            salaryText: "<span style='color: #6C2188'>10000-15000</span>",
          },
          {
            type: "Recruitment positions:",
            typeText: "Incoming inspector",
            planPeople: "Planning personnel:",
            planPeopleText: "2 person",
            job: "duty:",
            jobText: "Negatively inspect the appearance of the valve incoming materials to ensure that the components meet the appearance quality requirements; <br>" +
              "Timely reporting of non-conforming components;<br>" +
              "Complete records should be kept for handling non-conforming parts to facilitate the investigation of the reasons for non-compliance;<br>" +
              "Responsible for maintaining the cleanliness of the work area and ensuring an orderly work environment;<br>" +
              "Complete the work tasks assigned by superiors.",
            salary: "Salary Information:",
            salaryText: "<span style='color: #6C2188'>4500-6000</span>",
          },
          {
            type: "Recruitment positions:",
            typeText: "Testing technician",
            planPeople: "Planning personnel:",
            planPeopleText: "2 person",
            job: "duty:",
            jobText: "Test the product according to the testing plan and plan, and record the test results; <br>" +
              "Record in detail the defects discovered during the testing process and provide timely feedback to developers;<br>" +
              "Track defect repair status: Track reported defects to ensure they are repaired in a timely manner;<br>" +
              "Summarize the testing process and results, form a testing report, and provide a basis for product evaluation and improvement.",
            salary: "Salary Information:",
            salaryText: "<span style='color: #6C2188'>5000-7000</span>",
          },
        ]
      },
      {
        name: "Department: R & D Department",
        isShow: false,
        list: [
          {
            type: "Recruitment positions:",
            typeText: "Board Valve Developer",
            planPeople: "Planning personnel:",
            planPeopleText: "1 person",
            job: "duty:",
            jobText: "Responsible for the design and development of vacuum valve, responsible for the overall mechanical plan, mechanical structure design, and 3D/2D drawing; <br>" +
              "Responsible for assisting the quality of product research and development;<br>" +
              "Responsible for the production of new product standard specification materials;<br>" +
              "Responsible for the assembly and debugging of the new sample machine, and cooperate with the verification work;<br>" +
              "Responsible for completing the temporary work assigned by superiors.",
            salary: "Salary Information:",
            salaryText: "<span style='color: #6C2188'>15000-20000</span>",
          },
          {
            type: "Recruitment positions:",
            typeText: "Simulation engineer",
            planPeople: "Planning personnel:",
            planPeopleText: "2 person",
            job: "duty:",
            jobText: "Responsible for the analysis of valve mechanical structure and sports, dynamic solution, vibration reduction design, tolerance analysis, and flow guidance analysis; <br>" +
              "Responsible for assisting the quality of product research and development;<br>" +
              "Responsible for the production of new product standard specifications;<br>" +
              "Responsible for completing the temporary work assigned by superiors.",
            salary: "Salary Information:",
            salaryText: "<span style='color: #6C2188'>15000-20000</span>",
          },
          {
            type: "Recruitment positions:",
            typeText: "Rectangular valve developer",
            planPeople: "Planning personnel:",
            planPeopleText: "1 person",
            job: "duty:",
            jobText: "Responsible for the design and development of vacuum valve, responsible for the overall mechanical plan, mechanical structure design, and 3D/2D drawing; <br>" +
              "Responsible for assisting the quality of product research and development;<br>" +
              "Responsible for the production of new product standard specification materials;<br>" +
              "Responsible for the assembly and debugging of the new sample machine, and cooperate with the verification work;<br>" +
              "Responsible for completing the temporary work assigned by superiors.",
            salary: "Salary Information:",
            salaryText: "<span style='color: #6C2188'>15000-20000</span>",
          },
          {
            type: "Recruitment positions:",
            typeText: "Butterfly valve developer",
            planPeople: "Planning personnel:",
            planPeopleText: "1 person",
            job: "duty:",
            jobText: "Responsible for the design and development of vacuum valve, responsible for the overall mechanical plan, mechanical structure design, and 3D/2D drawing; <br>" +
              "Responsible for assisting the quality of product research and development;<br>" +
              "Responsible for the production of new product standard specification materials;<br>" +
              "Responsible for the assembly and debugging of the new sample machine, and cooperate with the verification work;<br>" +
              "Responsible for completing the temporary work assigned by superiors.",
            salary: "Salary Information:",
            salaryText: "<span style='color: #6C2188'>15000-20000</span>",
          },
          {
            type: "Recruitment positions:",
            typeText: "I-MOTION developer",
            planPeople: "Planning personnel:",
            planPeopleText: "2 person",
            job: "duty:",
            jobText: "Responsible for the design and development of vacuum valve, responsible for the overall mechanical solution, mechanical structure design, and 3D/2D drawing, responsible for the mechanics and force analysis of the structure, and the motion simulation of the structure; <br>" +
              "Responsible for assisting the quality of product research and development;<br>" +
              "Responsible for the production of new product standard specification materials;<br>" +
              "Responsible for the assembly and debugging of the new sample machine, and cooperate with the verification work;<br>" +
              "Responsible for completing the temporary work assigned by superiors.",
            salary: "Salary Information:",
            salaryText: "<span style='color: #6C2188'>15000-20000</span>",
          },
          {
            type: "Recruitment positions:",
            typeText: "Embedded Software Engineer",
            planPeople: "Planning personnel:",
            planPeopleText: "1 person",
            job: "duty:",
            jobText: "Responsible for the development, commissioning, and verification of the vacuum control valve embedded software;<br>" +
              "Responsible for the writing of product technology documents.",
            salary: "Salary Information:",
            salaryText: "<span style='color: #6C2188'>15000-20000</span>",
          },
          {
            type: "Recruitment positions:",
            typeText: "Test Engineer",
            planPeople: "Planning personnel:",
            planPeopleText: "1 person",
            job: "duty:",
            jobText: "Responsible for developing overall product testing strategies, reliability testing strategies, testing plans, and test case design;<br>" +
              "Responsible for product testing delivery, including unit testing, functional testing, and integration testing." +
              "Responsible for debugging and verifying new product prototypes, utilizing laboratory testing data to identify key performance values" +
              "Production site support, product problem analysis and resolution, customer on-site support, and other related tasks." +
              "Responsible for the production of new product standard specifications."+
              "Responsible for completing temporary tasks assigned by superiors.",
            salary: "Salary Information:",
            salaryText: "<span style='color: #6C2188'>15000-20000</span>",
          },
          {
            type: "Recruitment positions:",
            typeText: "Control valve R&D engineer (swing valve)",
            planPeople: "Planning personnel:",
            planPeopleText: "1 person",
            job: "duty:",
            jobText: "Responsible for the design and development of vacuum valves, responsible for the overall mechanical scheme, mechanical structure design, and 3D/2D drawing, responsible for mechanical structure analysis and kinematics, dynamic solving, vibration reduction design, tolerance analysis, etc;<br>" +
              "Responsible for assisting the quality of product research and development;<br>" +
              "Responsible for the production of new product standard specification materials;<br>" +
              "Responsible for the assembly and debugging of the new sample machine, and cooperate with the verification work;<br>" +
              "Responsible for completing the temporary work assigned by superiors.",
            salary: "Salary Information:",
            salaryText: "<span style='color: #6C2188'>15000-20000</span>",
          },
        ]
      },
      {
        name: "Department：Manufacturing Department",
        isShow: false,
        list: [
          {
            type: "Recruitment positions:",
            typeText: "Machining center (vertical machining)",
            planPeople: "Planning personnel:",
            planPeopleText: "8 person",
            job: "duty:",
            jobText: "Capable of independently operating the Doushan vertical machining center, familiar with commonly used cutting tools and measuring tools, familiar with routine operations such as straightening, centering, and tool alignment of parts;<br>" +
              "Responsible for daily maintenance and upkeep of equipment;<br>" +
              "Responsible for 5S within the region;<br>" +
              "Responsible for achieving daily output and quality goals.<br>",
            salary: "Salary Information:",
            salaryText: "<span style='color: #6C2188'>7000-11000</span>",
          },
          {
            type: "Recruitment positions:",
            typeText: "Processing Center (Wojia Dragon Gate)",
            planPeople: "Planning personnel:",
            planPeopleText: "3 person",
            job: "duty:",
            jobText: "Capable of independently operating a star view vertical dragon machining center, familiar with commonly used tool measuring tools, proficient in the installation and disassembly of tooling fixtures centering, and tool alignment of parts;<br>" +
              "Responsible for daily maintenance and upkeep of equipment;<br>" +
              "Responsible for 5S within the region;<br>" +
              "Responsible for achieving daily output and quality goals.<br>",
            salary: "Salary Information:",
            salaryText: "<span style='color: #6C2188'>8000-13000</span>",
          },
          {
            type: "Recruitment positions:",
            typeText: "CNC Lathe operator",
            planPeople: "Planning personnel:",
            planPeopleText: "5 person",
            job: "duty:",
            jobText: "Capable of independently operating Doushan vertical, horizontal, or cloud machine lathes, familiar with commonly used cutting tools and measuring tools, and able to independently write simple turning programs;<br>" +
              "Responsible for daily maintenance and upkeep of equipment;<br>" +
              "Responsible for 5S within the region;<br>" +
              "Responsible for achieving daily output and quality goals.<br>",
            salary: "Salary Information:",
            salaryText: "<span style='color: #6C2188'>8000-13000</span>",
          },
          {
            type: "Recruitment positions:",
            typeText: "Mechanic",
            planPeople: "Planning personnel:",
            planPeopleText: "1 person",
            job: "duty:",
            jobText: "Capable of independently solving mechanical faults, possessing knowledge in electrical aspects, understanding production environmental factors and related factory safety and fire protection knowledge;<br>" +
              "Responsible for the maintenance and upkeep of mechanical equipment throughout the company, supervising the daily maintenance of equipment by workshop employees, and filling out records;<br>" +
              "Establish an equipment maintenance ledger and carry out equipment maintenance and repair according to the established plan;<br>" +
              "According to the arrangement of workshop production tasks, quickly handle equipment abnormalities on the production line to ensure orderly production;<br>" +
              "Responsible for the acceptance work of new equipment, as well as the installation and commissioning of corresponding water and electrical equipment.",
            salary: "Salary Information:",
            salaryText: "<span style='color: #6C2188'>5000-7000</span>",
          },
        ]
      },
      {
        name: "Department: Quality Department",
        isShow: false,
        list: [
          {
            type: "Recruitment positions:",
            typeText: "Inspection",
            planPeople: "Planning personnel:",
            planPeopleText: "2 person",
            job: "duty:",
            jobText: "Confirm the inspection tools used by on-site employees before daily inspection, replace defective or damaged inspection tools, and guide employees in the correct use and maintenance of inspection tools;<br>" +
              "Supervise the accuracy of equipment inspection, self inspection, and self-service testing by production employees, and guide and supervise employees to complete them;<br>" +
              "Confirm on-site first piece and employee first piece inspection data, fill in shift handover records, and promptly report any abnormalities to department supervisors and successors;<br>" +
              "Cooperate with on-site machine adjustment, shutdown, and tool replacement to determine the first piece size, and assist department supervisors in tracking and recording workshop defects or phenomena;<br>" +
              "Other temporary tasks arranged by the department.",
            salary: "Salary Information:",
            salaryText: "<span style='color: #6C2188'>5000-7000</span>",
          },
          {
            type: "Recruitment positions:",
            typeText: "System Engineer",
            planPeople: "Planning personnel:",
            planPeopleText: "2 person",
            job: "duty:",
            jobText: "Planning, implementation, maintenance, improvement, and supervision and management during the implementation process of the system;<br>" +
              "Organize and implement internal system, process, and product audits within the company, responsible for accompanying customer audits, collecting and preparing documentation, and tracking and closing audit issues;<br>" +
              "Responsible for organizing the preparation, revision, training, distribution, and management of quality system documents;<br>" +
              "Organize the management of the company's measuring instruments, archives, etc;<br>" +
              "Other temporary tasks arranged by the department.",
            salary: "Salary Information:",
            salaryText: "<span style='color: #6C2188'>6000-12000</span>",
          },
          {
            type: "Recruitment positions:",
            typeText: "Quality Engineer",
            planPeople: "Planning personnel:",
            planPeopleText: "1 person",
            job: "duty:",
            jobText: "Implement departmental and annual quality plans, analyze and summarize monthly internal and external quality issues;<br>" +
              "Responsible for customer complaints and quick response, feedback failure anomalies to the internal team, resolve client issues in the short term, track improvement measures until the issues are resolved;<br>" +
              "Participate in quality planning in the early stage of new product development, mid-term quality control, and later quality assurance;<br>" +
              "Conduct initial judgment, analysis, improvement, and effectiveness verification on the generated defective products, and manage the daily work of IQC, POC, and 0QC;<br>" +
              "Other temporary tasks arranged by the department.",
            salary: "Salary Information:",
            salaryText: "<span style='color: #6C2188'>6000-12000</span>",
          },
          {
            type: "Recruitment positions:",
            typeText: "Quality Director",
            planPeople: "Planning personnel:",
            planPeopleText: "1 person",
            job: "duty:",
            jobText: "Responsible for formulating the overall quality strategy of the enterprise, and fully responsible for quality management in accordance with the needs of the enterprise's development strategy;<br>" +
              "Develop policies, processes, systems, and operational norms for quality control, supervise and inspect the implementation of quality system processes;<br>" +
              "Guide the construction of the IS016949 quality management system, and organize personnel to audit it to ensure effective control and operation;<br>" +
              "Hosting major quality themed meetings, coordinating the cooperation of various departments, and carrying out major quality improvement and cost reduction projects;<br>" +
              "Lead the handling of major quality risks and accidents, assist in handling customer complaints and returns, and develop improvement measures; <br>" +
              "Responsible for quality control of the supply chain and managing the supply quality of key materials.",
            salary: "Salary Information:",
            salaryText: "<span style='color: #6C2188'>20000-40000</span>",
          },
          {
            type: "Recruitment positions:",
            typeText: "Inspector",
            planPeople: "Planning personnel:",
            planPeopleText: "3 person",
            job: "duty:",
            jobText: "Receive incoming material inspection notifications from the warehouse, first/last pieces, semi-finished/finished products in the process, and conduct inspections according to inspection specifications, drawings, etc;<br>" +
              "After the inspection is completed, an accurate inspection report is issued, responsible for the measurement results, and the inspection records are organized and archived. After passing the inspection, work is reported according to the process, and any abnormalities found during the process are promptly reported;<br>" +
              "Summarize the problems found during inspection and promptly issue a defect notice;<br>" +
              "Other temporary tasks arranged by the department.",
            salary: "Salary Information:",
            salaryText: "<span style='color: #6C2188'>4500-6000</span>",
          },
        ]
      },
      {
        name: "Department: Manufacturing Engineering Department",
        isShow: false,
        list: [
          {
            type: "Recruitment positions:",
            typeText: "CNC programming",
            planPeople: "Planning personnel:",
            planPeopleText: "1 person",
            job: "duty:",
            jobText: "Responsible for process analysis, material evaluation, and tool evaluation of machining centers for parts;<br>" +
              "Responsible for programming, simulating and outputting relevant G code, program sheets, tool sheets, etc;<br>" +
              "Responsible for optimizing the process and program of processed parts, and improving efficiency;<br>" +
              "Responsible for handling some debugging issues feedback from the workshop and modifying unreasonable programs." ,
            salary: "Salary Information:",
            salaryText: "<span style='color: #6C2188'>:8000-16000</span>",
          },
          {
            type: "Recruitment positions:",
            typeText: "Process Engineer",
            planPeople: "Planning personnel:",
            planPeopleText: "1 person",
            job: "duty:",
            jobText: "Set up the process for the drawings of new products, prepare process documents, and create processing flow charts;<br>" +
              "Track the product process, inspect the execution of workshop processes, and stop behaviors that violate process discipline;<br>" +
              "Improve process documents and tooling drawings, explain the formulated process documents, and correct process documents that do not comply with the drawings;<br>" +
              "Timely evaluate the processing technology and working hours of the parts for the quoted project." ,
            salary: "Salary Information:",
            salaryText: "<span style='color: #6C2188'>8000-16000</span>",
          },
          {
            type: "Recruitment positions:",
            typeText: "Fixture Engineer",
            planPeople: "Planning personnel:",
            planPeopleText: "1 person",
            job: "duty:",
            jobText: "Standardization of fixture design and specifications;<br>" +
              "Proficient in using NX (UG) software, 3D modeling, 2D drawing;<br>" +
              "Fundamentals of CNC programming and mechanical processing technology;<br>" +
              "Understand the principles of hydraulic and pneumatic fixtures;<br>" +
              "Basic Excel operations.",
            salary: "Salary Information:",
            salaryText: "<span style='color: #6C2188'>10000-15000</span>",
          },
        ]
      },
    ],
    ConsultationImmediately: "Consult",
    contactUsText: "We are here to serve you",
    contactUsTexts:"contact us.",
    contactUsList: [
      // {
      //   title: "Sales Manager",
      //  titleText: "/ Responsible person",
      //   name: "叶晶莹 / Emily",
      //   phone: "138 1717 4371",
      //   email: "yejingying@jiashengvac.com",
      //   // address: "No. 9 Xinye Road, Economic Development Zone, Jingjiang City, Jiangsu Province",
      //   address: "Domicile: Shanghai"
      // },
      {
        // title: "销售部经理",
        title: "Account Manager",
        // titleText: "/ 负责人",
        titleText: "",
        name: "闻先生 / Mr.Wen",
        phone: "+86 151 8992 0371",
        email: "wenshuai@jiashengvac.com ",
        // address: "江苏省靖江市经济开发区新业路9号",
        address: "Domicile: Jiangsu"
      },
      {
        title: "Account Manager",
        titleText: "",
        name: "展女士 / Ms.Zhan",
        phone: "+86 151 8993 0567",
        email: "zhanwenjun@jiashengvac.com",
        // address: "No. 8 Wenchang Avenue, Beijing Economic and Technological Development Zone",
        address: "Domicile: Beijing"
      },
      {
        title: "Account Manager",
        titleText: "",
        name: " 蔡先生 / Johnson",
        phone: "+86 152 1661 3109",
        email: "johnson@jiashengvac.com",
        // address: "No. 8 Wenchang Avenue, Beijing Economic and Technological Development Zone",
        address: "Domicile: Shanghai"
      },
    ],
    select_list: [
      {
        name: "Mr.",
      },
      {
        name: "Ms.",
      },
    ],
    leaveUsMessage: "Leave us a message",
    leaveUsMessages: "Please send us a quick message through the form below, and we will reply to you as soon as possible.",
    call: "Title:",
    pleaseChoose:"Please select.",
    choose: "choose",
    name: "name",
    notEmpty: "not Empty.",
    lastname: "surname:",
    dept: "company:",
    department: "department:",
    emailC: "email:",
    emailText: "Must be a valid email address.",
    phone: "Phone:",
    CountryRegion: "Country/Region:",
    Topic:"Topic:",
    YourMessage:"Your message:",
    UploadFiles: "Upload files",
    cText: "Maximum file size for uploading: 15 MB, only accept JPG, PNG, CAD, and PDF files.",
    cText2: "I agree to allow this website to store the information I have submitted so that it can respond to my inquiry.",
    sendMessage: "Sending messages",
    jszkMemberLogin: "Member login",
    memberLogin: "Member login",
    userNameRequired: "enter one user name",
    passWordRequired: "Please enter password",
    login: "login",
    forgetPassword: "Forgot password",
    notMember: "Not yet a member",
    quicklyRegister: "Quick registration",
    jszkMemberRegistration: "Member registration",
    registered: "Enterprise registration",
    registeredText1: "Existing account, go",
    registeredText2: "login",
    registeredList: [
      {
        name: "Enterprise Name:",
        text: "Please enter the company name",
        required: "Please enter the company name",
      },
      {
        name: "Mobile number:",
        text: "Please enter your phone number or email address",
        required: "Please fill in the account you used to log in with",
      },
      {
        name: "Verification Code:",
        text: "Please enter the verification code",
        button: "Please enter the verification code",
      },
      {
        name: "Real name:",
        text: "Please provide your real name",
      },
      {
        name: "Set password:",
        text: "Set password",
        required: "Letters or numbers greater than 6 characters but less than 20 characters",
      },
      {
        name: "Confirm password:",
        text: "Confirm password",
        required: "Enter your password again to confirm",
      },
    ],
    readAndAgree: "Read and agree",
    protocol: "《Website Service Agreement》",
    register: "register",
    registerContent: "Congratulations, registration successful",
    registerContentBtn: "Download",
    retrievePasswordText: "Forgot password",
    retrievePassword: "Forgot password",
    retrieveList: [
      {
        name: "Registration company name:",
        text: "Please enter the company name",
        required: "Please fill in the full name of the company",
      },
      {
        name: "Registration phone number:",
        text: "Please enter your phone number or email address",
        required: "Please fill in the account you used to log in with",
      },
      {
        name: "Real name:",
        text: "Please provide your real name",
      },
      {
        name: "Set new password:",
        text: "Set password",
        required: "Letters or numbers greater than 6 characters but less than 20 characters",
      },
      {
        name: "Confirm new password:",
        text: "Confirm password",
        required: "Enter your password again to confirm",
      },
      {
        name: "Verification Code:",
        text: "Please enter the verification code",
        button: "Please enter the verification code",
      },
    ],
    confirm: "confirm",
    honorText1: "Enterprise Honor Certificate and Patent Certificate",
    honorText2: "Honorary certificate",
    honorText3: "check",
    honorText4: "Patent certificate",
    backNews: "back news",
    checkText: "Please check the option",
    loginSuccess: "Login successful",
    retrievePasswordTextR: "Password changed successfully",
    uploadSuccess: "Upload successful",
    contactUsChoose: "Select country/region",
    // https:'http://a34.madpay.com',
    https: 'https://www.jiashengvac.com',
    // https: 'http://admin.jiashengvac.com',
    bannerBg1: require('../imgs/bannerBg1_en.png'),
    bannerBg2: require('../imgs/bannerBg2_en.png'),
    bannerBg3: require('../imgs/bannerBg3_en.png'),
    bannerBg4: require('../imgs/bannerBg4_en.png'),
    bannerBg5: require('../imgs/bannerBg5_en.png'),
    bannerBg6: require('../imgs/bannerBg6_en.png')
  },
};



// WEBPACK FOOTER //
// ./src/assets/lang/en.js